import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const pageSectionDefaultVariants = {
  "maxWidth": "lg"
}
const pageSectionCompoundVariants = []

const pageSectionSlotNames = [
  [
    "root",
    "page-section__root"
  ]
]
const pageSectionSlotFns = /* @__PURE__ */ pageSectionSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, pageSectionDefaultVariants, getSlotCompoundVariant(pageSectionCompoundVariants, slotName))])

const pageSectionFn = memo((props = {}) => {
  return Object.fromEntries(pageSectionSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const pageSectionVariantKeys = [
  "maxWidth"
]
const getVariantProps = (variants) => ({ ...pageSectionDefaultVariants, ...compact(variants) })

export const pageSection = /* @__PURE__ */ Object.assign(pageSectionFn, {
  __recipe__: false,
  __name__: 'pageSection',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: pageSectionVariantKeys,
  variantMap: {
  "maxWidth": [
    "sm",
    "md",
    "lg",
    "full"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, pageSectionVariantKeys)
  },
  getVariantProps
})